<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Login',
})
</script>
<template>
  <div class="main">
    <a-form id="formLogin" class="user-layout-login" @submit="handleSubmit" :model="formRef" :rules="rulesRef">
      <div class="user-layout-login-logo">
        <img src="../../assets/login_slices/logo_group.png" />
      </div>
      <a-steps class="login-steps" type="navigation" size="small" :current="customActiveKey" :items="[
        {
          title: '用户名登录'
        },
        {
          title: '验证码登录'
        }
      ]"></a-steps>
      <template v-if="customActiveKey == 0">
        <!-- 账户密码登录 -->
        <a-form-item name="username">
          <a-input class="login-input" maxlength="20" :bordered="false" size="large" type="text" placeholder="请输入账号"
            v-model:value="formRef.username" @blur="(e) => (formRef.username = e.target.value.replace(/\s/g, ''))">
            <template #prefix>
              <img class="icon-img icon-phone" src="../../assets/login_slices/icon_phone.png" alt="">
            </template>
          </a-input>
        </a-form-item>

        <a-form-item name="password">
          <a-input-password class="login-input" :bordered="false" size="large" placeholder="请输入密码"
            v-model:value="formRef.password" @blur="(e) => (formRef.password = e.target.value.replace(/\s/g, ''))">
            <template #prefix>
              <img class="icon-img icon-lock" src="../../assets/login_slices/icon_lock.png" alt="">
            </template>
          </a-input-password>
        </a-form-item>
      </template>
      <template v-else>
        <!-- 手机号登录 -->
        <a-form-item name="maskTel">
          <a-input class="login-input" maxlength="11" :bordered="false" size="large" type="text" placeholder="请输入手机号"
            disabled v-model:value="formRef.maskTel">
            <MobileOutlined :style="{ color: 'rgba(0,0,0,.25)' }" />
          </a-input>
        </a-form-item>

        <a-row :gutter="16">
          <a-col class="gutter-row" :span="16">
            <a-form-item name="code">
              <a-input class="login-input" :bordered="false" size="large" type="text" placeholder="请输入验证码" maxlength="6"
                v-model:value="formRef.code">
                <MailOutlined :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input>
            </a-form-item>
          </a-col>
          <a-col class="gutter-row" :span="8">
            <a-button class="getCaptcha" tabindex="-1" :disabled="state.smsSendBtn" @click.stop.prevent="getCaptcha">
              {{ (!state.smsSendBtn && '获取验证码') || state.time + ' s' }}
            </a-button>
          </a-col>
        </a-row>
      </template>

      <a-form-item style="margin-top: 24px">
        <a-button size="large" htmlType="submit" class="login-button" :loading="state.loginBtn"
          :disabled="state.loginBtn">下一步</a-button>
      </a-form-item>
    </a-form>
    <div id="captcha" :class="state.data.captchaConfig.config.product === 'bind' ? 'hideHeight' : ''">
      <AliCaptcha :captcha-config="state.data.captchaConfig" />
    </div>
  </div>
</template>

<script lang="ts" setup name="Login">
import { ref, reactive, UnwrapRef } from 'vue'
import { Form, message } from 'ant-design-vue'
import { loginSuccess, requestFailed } from './helper'
import { useRouter } from 'vue-router'
import { MobileOutlined, MailOutlined, AlipayCircleOutlined, TaobaoCircleOutlined, WeiboCircleOutlined, UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import config from '@/config/defaultSettings'
import generateAsyncRoutes from '@/router/generateAsyncRoutes'
import { useGetCaptcha } from './helper'

import { maskPhone } from '@/utils/toolsValidate'
import { useLogin } from '@/store/login'
import type { Rule } from 'ant-design-vue/es/form'
import { desEncrypt } from '@/utils/des'
import ls from '@/utils/Storage'
import AliCaptcha from '@/components/aliCaptcha/index.vue'

const loginApi = useLogin()

const useForm = Form.useForm
const router = useRouter()

const captchaHandler = (captchaObj: any) => {
  ; (window as any).captchaObj = captchaObj
  captchaObj
    .appendTo('#captcha')
    .onReady(function () {
      console.log('ready')
    })
    .onNextReady(function () {
      console.log('nextReady')
    })
    .onBoxShow(function () {
      console.log('boxShow')
    })
    .onError(function (e: any) {
      console.log(e)
    })
    .onSuccess(function () {
      if (state.data.captchaConfig.config.product === 'bind') {
        validateCode()
      }
    })
}

const state = reactive({
  time: 60,
  loginBtn: false,
  // login type: 0 email, 1 username, 2 telephone
  loginType: 0,
  smsSendBtn: false,
  data: {
    captchaConfig: {
      config: {
        captchaId: 'b9f4f1f07063bb1f3cb767d9a1fddaf1',
        language: 'zho',
        product: 'bind'
      },
      handler: captchaHandler
    }
  }
})

// #region 表单相关
const formRef: UnwrapRef<any> = reactive({
  username: '',
  password: '',
  maskTel: '',
  tel: '',
  code: '',
  key: ''
})
const rulesRef: Record<string, Rule[]> = {
  username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ],
  maskTel: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
  code: [{ required: true, message: '请输入验证码', validateTrigger: 'blur' }]
}
const { validate } = useForm(formRef, rulesRef)
const handleSubmit = (e: Event) => {
  e.preventDefault()
  state.loginBtn = true
  const validateFieldsKey = customActiveKey.value === 0 ? ['username', 'password'] : ['mobile', 'code']
  validate(validateFieldsKey)
    .then(async () => {
      if (customActiveKey.value === 0) {
        const userNameKey = (await loginApi.getUserNamekey(formRef.username)) as string
        const pwd = desEncrypt(formRef.password, userNameKey)
        const info = (await loginApi.loginStepOne({ username: formRef.username, password: pwd })) as { tel: string; key: string }
        Object.assign(formRef, {
          maskTel: maskPhone(info.tel),
          tel: info.tel,
          key: info.key
        })
        customActiveKey.value = 1
      } else {
        const info = await loginApi.loginStepTwo({
          code: formRef.code,
          key: formRef.key,
          tel: formRef.tel
        })
        ls.set('ACCESS_TOKEN', info)
        const userInfo = (await loginApi.getUserInfo()) as any
        if (userInfo.roleType !== 'admin' && (userInfo.freeze == '0' || !userInfo.treeMenu?.length)) {
          return
        }
        router.push({ path: '/' })
      }
    })
    .catch(() => { })
    .finally(() => {
      state.loginBtn = false
    })
}
// #endregion

//#region 切换tab
const customActiveKey = ref<number>(0)

//#endregion

//#region 获取验证码
const getCaptcha = (e: Event) => {
  e.preventDefault()
  validate(['mobile']).then(async (res) => {
    console.log(123)

    // if (state.time > 0) return // 防止重复点击
    if (state.data.captchaConfig.config.product === 'bind') {
      if (window.captchaObj) {
        ; (window as any).captchaObj.showCaptcha()
      } else {
        alert('请等待验证初始化完成')
        return false
      }
    } else {
      validateCode()
    }
  })
}
//#endregion

const validateCode = async () => {
  let result = (window as any).captchaObj.getValidate()
  if (!result) {
    alert('请先完成验证！')
    return
  }
  try {
    let parmas = {
      tel: formRef.tel,
      type: 1,
      captchaOutput: result.captcha_output,
      genTime: result.gen_time,
      lotNumber: result.lot_number,
      passToken: result.pass_token
    }
    await loginApi.sendMsg(parmas)

    state.smsSendBtn = true
    const interval = window.setInterval(() => {
      if (state.time-- <= 0) {
        state.time = 60
        state.smsSendBtn = false
        window.clearInterval(interval)
      }
    }, 1000)
    message.success('验证码发送成功', 1)
  } catch (error) {
    state.time = 0 // 发送失败也要重置倒计时（可选）
  }
}

//#region TwoStepCaptcha暂时没用
const requiredTwoStepCaptcha = ref<number>(0)
const stepCaptchaVisible = ref<boolean>(false)
const stepCaptchaSuccess = (res) => {
  loginSuccess(res, router)
}
const stepCaptchaCancel = () => {
  // api.logout().then(() => {
  //   state.loginBtn = false
  //   stepCaptchaVisible.value = false
  // })
}
//#endregion
</script>

<style lang="less" scoped>
@import '../../style/index.less';

.user-layout-login {
  width: 368px;
  max-width: 100%;
  padding: 32px;
  border-radius: 8px;

  @media (max-width: 856px) {
    background: rgba(255, 255, 255, 0.85);
  }

  .user-layout-login-logo {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 65px;

    img {
      width: 273px;
      height: 122px;
    }
  }

  .icon-img {
    width: auto;
    height: 24px;
    max-width: 24px;
    object-fit: contain;
    padding-right: 10px;
    border-right: solid 1px #D5DEE7;

    &.icon-phone {
      width: 22px;
      height: 34px;
    }

    &.icon-lock {
      width: 24px;
      height: 30px;
    }
  }

  label {
    font-size: 14px;
  }

  :deep(.ant-input),
  :deep(.ant-input-affix-wrapper) {
    width: 100%;
  }

  .login-steps {
    margin-bottom: 24px;

    :deep(.ant-steps-item-title) {
      font-size: 14px;
    }
  }

  .login-input {
    background: #FFFFFF;
    border: 1px solid #E4EBF1;
    border-radius: 22px;

    :deep(.ant-input) {
      background: transparent;
      font-size: 16px !important;
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;
    }
  }

  :deep(.ant-input-affix-wrapper) {
    .ant-input-prefix {
      margin-inline-end: 12px;
    }
  }

  .getCaptcha {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 22px;
    padding: 0 8px;
    font-size: 13px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 44px;
    width: 100%;
    border-radius: 22px;
    background: #0B0B0B;
    border-color: #0B0B0B;
    color: #FFFFFF;
    box-shadow: none;

    &:focus {
      filter: brightness(1.05);
    }

    &:hover {
      filter: brightness(1.35);
    }

    &:active,
    &:focus:active {
      filter: brightness(0.65) !important;
    }
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .anticon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: @primary-color;
      }
    }

    .register {
      float: right;
    }
  }
}
</style>
